import store from "store2";
import lerp from "lerp";

const drawDonutTimer = (ctx, canvas, remainingTime, totalTime, color) => {
  const width = canvas.width;
  const height = canvas.height;
  const progress = remainingTime / totalTime;

  // Clear the canvas
  ctx.clearRect(0, 0, width, height);

  // Draw the background circle
  ctx.beginPath();
  ctx.arc(width / 2, height / 2, 80, 0, Math.PI * 2);
  ctx.fillStyle = "rgb(128, 128, 128)";
  ctx.fill();

  // Draw the remaining time arc
  ctx.beginPath();
  ctx.arc(
    width / 2,
    height / 2,
    65,
    -Math.PI / 2,
    -Math.PI / 2 + Math.PI * 2 * progress,
    false,
  );
  ctx.lineWidth = 30;
  ctx.lineCap = "round";
  ctx.strokeStyle = `rgb(${color.r}, ${color.g}, ${color.b})`;
  ctx.stroke();

  // Draw the inner circle
  ctx.beginPath();
  ctx.arc(width / 2, height / 2, 50, 0, Math.PI * 2);
  ctx.fillStyle = "#fff";
  ctx.fill();

  /*
    //Write time
    ctx.font = '20px Arial';
    ctx.fillStyle = '#333';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText(`${Math.ceil(remainingTime/10)} s`, width / 2, height / 2);*/
};

export const startTimerGPT = (
  totalTime,
  interval,
  ctx,
  canvas,
  colorCodes,
  step,
) => {
  let countdown = document.getElementById("canvas-timer-gpt");
  countdown.style.visibility = "visible";

  let remainingTime = totalTime;

  const { alert, warning, info } = colorCodes;
  let startColor = { r: 65, g: 184, b: 131 };
  let endColor = startColor;
  let color = startColor;
  let r, g, b, t;

  let intervalId = setInterval(() => {
    remainingTime--;

    if (remainingTime <= alert.threshold) {
      let elapsedTime = alert.threshold - remainingTime;
      endColor = { r: 255, g: 0, b: 0 };
      if (elapsedTime < step) {
        t = elapsedTime / step;
        r = lerp(startColor.r, endColor.r, t);
        g = lerp(startColor.g, endColor.g, t);
        b = lerp(startColor.b, endColor.b, t);
        color = { r, g, b };
      } else {
        color = endColor;
        startColor = endColor;
      }
    } else if (remainingTime <= warning.threshold) {
      let elapsedTime = warning.threshold - remainingTime;
      endColor = { r: 255, g: 165, b: 0 };
      if (elapsedTime < step) {
        t = elapsedTime / step;
        r = lerp(startColor.r, endColor.r, t);
        g = lerp(startColor.g, endColor.g, t);
        b = lerp(startColor.b, endColor.b, t);
        color = { r, g, b };
      } else {
        color = endColor;
        startColor = endColor;
      }
    }
    drawDonutTimer(ctx, canvas, remainingTime, totalTime, color);
  }, interval);

  store.session.set("intervalId", intervalId);
};
